import { render, staticRenderFns } from "./provision-features.vue?vue&type=template&id=f163c340&scoped=true&"
import script from "./provision-features.vue?vue&type=script&lang=js&"
export * from "./provision-features.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f163c340",
  null
  
)

export default component.exports